import { ComponentFunction } from "@glidejs/glide";
import Glide from "@glidejs/glide";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";

@ModuleName("CategoryFilter")
export class CategoryFilter implements AxInit {

    private SubGroupIds: Int32Array;

    AxInit(init: Int32Array): void {
        this.SubGroupIds = init;

        if (this.SubGroupIds == null || this.SubGroupIds.length === 0) {
            return;
        }

        window.addEventListener("scroll", x => { this.CheckTopOffset() });

        let glide = new Glide('#intro',
            {
                type: 'slider',
                rewind: false,
                bound: true,
                gap: 0,
                perView: 4,
                breakpoints: {
                    800: {
                        perView: 2
                    },
                    480: {
                        perView: 1
                    }
                },
                classes: {
                    activeSlide: 'ax-glide__sub_cat_slide--active',
                    disabledArrow: 'glide__arrow--disabled'
                },
            });

        //glide.mount();

        glide.on('run.before', e => {
            e.steps = e.direction === '>' ? -glide.settings.perView : glide.settings.perView
        })

        glide.mount({
            'DisableControls': this.updateGlideFunc
        });

        $('#btn_reset_groups').click(x => {
            this.ResetFilter();

            this.RemoveActiveClass();
            x.target.classList.add("ax-btn-subGroups-active");
        });

        $('.btn_filter_group').click(x => {
            const groupId = (x.target as HTMLButtonElement).getAttribute('data-groupId');
            this.FilterByGroupId(groupId);

            this.RemoveActiveClass();

            document.getElementById("btn_reset_groups").classList.remove("ax-btn-subGroups-active");

            x.target.classList.add("ax-btn-subGroups-active");
        });
    }

    private updateGlideFunc: ComponentFunction = (glide: Glide.Static, Components: any, Events: any) => {

        const PREV_CONTROL_SELECTOR = "[data-glide-dir='<']";
        const NEXT_CONTROL_SELECTOR = "[data-glide-dir='>']";
        const component = {
            buildAfter() {
                this.prevBtn = Components.Html.root.querySelector(PREV_CONTROL_SELECTOR);
                this.nextBtn = Components.Html.root.querySelector(NEXT_CONTROL_SELECTOR);
            },
            handleDisable() {
                const perView = glide.settings.perView;
                const slidesCount = Components.Html.slides.length;

                this.prevBtn.disabled = (glide.index <= 0);
                this.nextBtn.disabled = (glide.index >= slidesCount - perView);
            },
            mount() {
            }
        };

        Events.on("build.after", function () {
            component.buildAfter();
            component.handleDisable();
        });
        Events.on("run.after", function () {
            component.handleDisable();
        });
        return component;
    }

    CheckTopOffset(): void {

        let headerHeight = $('#ax-category-header').height();

        if (document.body.scrollTop > $('.ax-header').height() + headerHeight || document.documentElement.scrollTop > $('.ax-header').height() + headerHeight) {
            $('#ax-subcat-menu-holder').addClass('ax-subCat-glider-fixed-top');
            $('#ax-subCat-slider-frame').removeClass('ax-subCat-slider-frame-big');
            $('#ax-subCat-slider-frame').addClass('ax-subCat-slider-frame-small');

        } else {
            $('#ax-subcat-menu-holder').removeClass('ax-subCat-glider-fixed-top');
            $('#ax-subCat-slider-frame').addClass('ax-subCat-slider-frame-big');
            $('#ax-subCat-slider-frame').removeClass('ax-subCat-slider-frame-small');


           
        }
    }

    FilterByGroupId(groupId: string) {
        this.ResetFilter();

        let elements = document.getElementsByClassName("ax-category-cat-holder");

        for (let i = 0; i < elements.length; i++) {
            let tempId = elements[i].getAttribute('data-groupId');

            if (tempId != groupId) {
                $(elements[i]).hide();
            }
        }
    }

    RemoveActiveClass() {
        let elements = document.getElementsByClassName("btn_filter_group");

        for (let i = 0; i < elements.length; i++) {
            elements[i].classList.remove("ax-btn-subGroups-active");
        }
    }

    ResetFilter() {
        let elements = document.getElementsByClassName("ax-category-cat-holder");

        for (let i = 0; i < elements.length; i++) {
            let tempId = elements[i].getAttribute('data-groupId');

            $(elements[i]).show();
        }
    }
}

interface GliderMovement {
    direction: string;
    steps: string;
}